module.exports = __webpack_public_path__ + "img/legtJM-fr-pix.94871147.jpg";